import chalk from "chalk";
import { getCoordinatorConfig, getCoordinatorConfigAddress } from "@crunchdao/sdk";
import { log } from "@crunchdao/sdk";
import { formatAddressWithLink } from "./address-utils";
import { createTable } from "./table-utils";

export async function displayCoordinatorConfig(program: any, network: string): Promise<void> {
  try {
    log.info("Fetching coordinator configuration...");
    const coordinatorConfig = await getCoordinatorConfig(program);
    const mainTable = createTable({ colWidths: [30, 40] });

    // Display as a table
    mainTable.push(
      [
        chalk.yellow("Config Address"),
        formatAddressWithLink(getCoordinatorConfigAddress(program).toBase58(), network),
      ],
      [chalk.yellow("Bump"), coordinatorConfig.bump.toString()],
      [
        chalk.yellow("Admin Authority"),
        formatAddressWithLink(coordinatorConfig.coordinatorAdminAuthority.toBase58(), network),
      ],
      //[chalk.yellow("Reward Program Authority"), formatAddressWithLink(coordinatorConfig.rewardProgramAuthority.toBase58(), network)],
      //[chalk.yellow("Slash Custody"), formatAddressWithLink(coordinatorConfig.slashCustody.toBase58(), network)],
      [
        chalk.yellow("USDC Mint"),
        formatAddressWithLink(coordinatorConfig.usdcMint.toBase58(), network),
      ],
      [chalk.yellow("Burn Margin %"), coordinatorConfig.burnMarginPercentage.toString()],
      [
        chalk.yellow("Foundation Margin %"),
        coordinatorConfig.foundationMarginPercentage.toString(),
      ],
      [chalk.yellow("Claim Expiry Seconds"), coordinatorConfig.claimExpirySeconds.toString()],
      [
        chalk.yellow("Foundation Wallet"),
        formatAddressWithLink(coordinatorConfig.foundationWallet.toBase58(), network),
      ],
      [
        chalk.yellow("Proposed Admin Authority"),
        coordinatorConfig.proposedCoordinatorAdminAuthority
          ? formatAddressWithLink(
              coordinatorConfig.proposedCoordinatorAdminAuthority.toBase58(),
              network
            )
          : "None",
      ]
    );

    console.log(mainTable.toString());
  } catch (error) {
    log.error("Error fetching coordinator config:", error);
  }
}
